import {FastField, useField, useFormikContext} from "formik";
import React, {Fragment} from "react";
import MuiPhoneNumber from "material-ui-phone-number";

export const PhoneField = ({...props}) => {
    const {setFieldValue} = useFormikContext();
    const [field, meta] = useField(props);
    const badInput = (meta) => {return !!meta.touched && !!meta.error};
    return(<Fragment>
        <FastField
            {...field}
            {...props}
            component={MuiPhoneNumber}
            placeholder={"Enter phone number"}
            defaultCountry={"us"}
            onlyCountries={['us']}
            disableCountryCode={true}
            disableDropdown={true}
            type={"tel"}
            selected={field.value || null}
            onChange={val => {
                setFieldValue(field.name, val)
            }}
            error={badInput(meta)}
            helperText={badInput(meta) ? meta.error : null}
        />
    </Fragment>);
};